import EditProfileDialog from "./EditProfileDialog";

export function WordpressToken() {
  return <EditProfileDialog dialog="tokens" />;
}
